/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
};

export const resourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    setResources: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setResources } = resourcesSlice.actions;

export default resourcesSlice.reducer;
